/* eslint-disable */

import React, { useState, useEffect } from 'react'
import waTemplateSvc from 'services/waTemplateSvc';
import applicationSvc from "services/applicationSvc";
import moment from 'moment';
import Image from '_assets/svg/image.svg';
import File from '_assets/svg/file.svg';
import Video from '_assets/svg/video.svg';
import Location from '_assets/svg/location.svg';
import Phone from '_assets/svg/phone.svg';
import ExLink from '_assets/svg/external-link.svg';
import HelpCircle from '_assets/svg/help-circle.svg';
import Copycodeblue from '_assets/svg/copy-code-blue.svg';

// helpers
import { stripTags } from 'utils/helpers';

function PhoneMediaPreview(props) {
  const [isMasking, setMasking] = useState("");
  const [previewData, setPreviewData] = useState();
  const { 
    className, 
    chooseData, 
    isIndexPage, 
    onPreview, 
    isFooterMessage, 
    isBodyVariable, 
    isValueCodeDelivery,
    isValueExpiryTime,
    isExpiryTime,
    isSecurityRecomendation
   } = props;

  let preview = previewData;
  let masking = "OCA Indonesia";

  function convert(message) {
    if (message) {
      return message
        .replace(/(?:\*)((?:(?!\*|\n).)+)(?:\*)/g, '<b>$1</b>')
        .replace(/(?:_)((?:(?!\n|_).)+)(?:_)/g, '<i>$1</i>');
      // .replace(/(?:~)(?:(?!\s))((?:(?!\n|~).)+)(?:~)/g,'<s>$1</s>')
      // .replace(/(?:--)(?:(?!\s))((?:(?!\n|--).)+)(?:--)/g,'<u>$1</u>')
      // .replace(/(?:```)(?:(?!\s))((?:(?!\n|```).)+)(?:```)/g,'<tt>$1</tt>');
    }
  }

  async function handleMaskingWa() {
    await applicationSvc.getAll().then((response) => {
      console.log(response.data.data[0]._id);
      waTemplateSvc.getMaskingWa(response.data.data[0]._id).then((res) => {
        setMasking(res.data.data.whatsapp.senderName)
      })
        .catch((error) => {
          console.log(error)
        })
    }).catch(() => { });

  }

  function checkReg(str) {
    if (typeof str !== 'undefined') {
      let string = str
      string = string.replace(/_(.*?)_/g, `<i>$1</i>`)
      string = string.replace(/~(.*?)~/g, `<del>$1</del>`)
      string = string.replace(/```(.*?)```/g, `<tt>$1</tt>`)
      string = string.replace(/\*(.*?)\*/g, `<b>$1</b>`)
      string = string.replace(/(\r\n|\n|\r)/gm, "<br />");
      return { __html: string };
    }

    return { __html: str };
  }

  useEffect(() => {
    setMasking("OCA Indonesia")
    // handleMaskingWa()
 
    // setPreviewData(chooseData[isIndexPage])
  }, [onPreview,])
  console.log('onPreview', isValueExpiryTime)

  return (
    <div className={`wrapper_new_phone ${className}`}>
      <div className={`wrapper_phone_middle`}>
        <p className='preview fsize-16 fweight-600 cl-neutral400 mb-2'>Preview</p>
        <div className="phone-preview">
          <div className="preview-text custom-scrollbar p-3">
            <div className="mb-2">
              <div className={`sms-text`}>
                <p className='fsize-14 cl-black mb-3'>
                  <strong> {isBodyVariable.variable} </strong> 
                  {isBodyVariable.text}  {isSecurityRecomendation && 
                    <span>
                     {isBodyVariable.recomendationSecurity}
                  </span>
                  }
                </p>
                <div className='d-flex align-items-center mb-3'>
                  {isExpiryTime && 
                    <p className='text-end fsize-12 fweight-400 cl-grey me-auto mb-0'>{isValueExpiryTime.wording + ' ' + isValueExpiryTime.time + ' ' + isValueExpiryTime.nameTimes}</p>
                  }
                  <p className='text-end ms-auto fsize-12 fweight-400 cl-grey mb-0'>{moment(new Date(new Date())).format('H:mm')}</p>
                </div>
                {isFooterMessage.text && 
                  <div className={`d-flex button_authentication justify-content-center align-items-center flex-wrap mt-2 pt-2`}>
                    <img src={Copycodeblue} alt='Copycodeblue' />
                    <span className="fsize-14 fweight-500 ms-2">
                      {isFooterMessage.text}
                    </span>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PhoneMediaPreview